import React from 'react';
import Link from 'next/link';

import { ButtonColor } from '../../../types/button';

import { Wrapper } from './atoms/Wrapper';
import { Button } from '../../common/Button';
import { Heading } from './atoms/Heading';
import { ButtonWrapper } from './atoms/ButtonWrapper';

interface Props {
    id: number;
    title: string;
    shortDescription: string;
}
export const JobItem: React.FC<Props> = ({ id, title, shortDescription }) => (
    <Wrapper key={id}>
        <Heading>{title}</Heading>
        <p>{shortDescription}</p>
        <ButtonWrapper>
            <Link href="/vacatures/[id]" as={`/vacatures/${id}`}>
                <Button color={ButtonColor.orange} more={true}>
                    Lees meer
                </Button>
            </Link>
        </ButtonWrapper>
    </Wrapper>
);
